Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);var _merge2=require("lodash/merge");var _merge3=_interopRequireDefault(_merge2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}


var fontDictionary={
"American Typewriter":2.09,
"Baskerville":2.51,
"Georgia":2.27,
"Hoefler Text":2.39,
"Palatino":2.26,
"Times New Roman":2.48,
"Arial":2.26,
"Gill Sans":2.47,
"Gill Sans 300":2.58,
"Helvetica Neue":2.24,
"Lucida Grande":2.05,
"Tahoma":2.25,
"Trebuchet MS":2.2,
"Verdana":1.96,
"Courier New":1.67,
"cursive":1.84,
"fantasy":2.09,
"monospace":1.81,
"serif":2.04,
"sans-serif":1.89};



var absoluteMeasurementUnitsToPixels={
"mm":3.8,
"sm":38,
"pt":1.33,
"pc":16,
"in":96,
"px":1};

var relativeMeasurementUnitsCoef={
"em":1,
"ex":0.5};


var coefficients={
averageFontConstant:2.1675,
widthOverlapCoef:1.25,
heightOverlapCoef:1.05,
lineCapitalCoef:1.15,
lineSpaceHeightCoef:0.2};

var defaultStyle={
lineHeight:1,
letterSpacing:"0px",
fontSize:0,
angle:0,
fontFamily:""};


var _degreeToRadian=function _degreeToRadian(angle){return angle*Math.PI/180;};

var _getFontCharacterConstant=function _getFontCharacterConstant(fontFamily){
var firstFont=fontFamily.split(",")[0].replace(/'|"/g,"");
return fontDictionary[firstFont]||coefficients.averageFontConstant;
};

var _splitToLines=function _splitToLines(text){
return Array.isArray(text)?text:text.toString().split(/\r\n|\r|\n/g);
};

var _getSizeWithRotate=function _getSizeWithRotate(axisSize,dependentSize,angle){
var angleInRadian=_degreeToRadian(angle);
return Math.abs(Math.cos(angleInRadian)*axisSize)+
Math.abs(Math.sin(angleInRadian)*dependentSize);
};







var convertLengthToPixels=function convertLengthToPixels(length,fontSize){
var attribute=length.match(/[a-zA-Z%]+/)[0];
var value=length.match(/[0-9.,]+/);
var result=void 0;
if(absoluteMeasurementUnitsToPixels.hasOwnProperty(attribute)){
result=value*absoluteMeasurementUnitsToPixels[attribute];
}else if(relativeMeasurementUnitsCoef.hasOwnProperty(attribute)){
result=(fontSize?value*fontSize:value*coefficients.defaultFontSize)*
relativeMeasurementUnitsCoef[attribute];
}else{
result=value;
}
return result;
};

var _prepareParams=function _prepareParams(inputStyle,index){
var lineStyle=Array.isArray(inputStyle)?inputStyle[index]:inputStyle;
var style=(0,_defaults3.default)({},lineStyle,defaultStyle);
return(0,_merge3.default)({},style,{
characterConstant:style.characterConstant||_getFontCharacterConstant(style.fontFamily),
letterSpacing:convertLengthToPixels(style.letterSpacing,style.fontSize),
fontSize:typeof style.fontSize==="number"?
style.fontSize:
convertLengthToPixels(String(style.fontSize))});

};

var _approximateTextWidthInternal=function _approximateTextWidthInternal(text,style){
var widths=_splitToLines(text).map(function(line,index){
var len=line.toString().length;var _prepareParams2=
_prepareParams(style,index),fontSize=_prepareParams2.fontSize,characterConstant=_prepareParams2.characterConstant,letterSpacing=_prepareParams2.letterSpacing;
return len*fontSize/characterConstant+letterSpacing*Math.max(len-1,0);
});
return Math.max.apply(Math,_toConsumableArray(widths));
};

var _approximateTextHeightInternal=function _approximateTextHeightInternal(text,style){
return _splitToLines(text).reduce(function(total,line,index){
var lineStyle=_prepareParams(style,index);
var height=lineStyle.fontSize*coefficients.lineCapitalCoef;
var emptySpace=index===0?0:lineStyle.fontSize*coefficients.lineSpaceHeightCoef;
return total+lineStyle.lineHeight*(height+emptySpace);
},0);
};













var approximateTextSize=function approximateTextSize(text,style){
var angle=Array.isArray(style)?style[0]&&style[0].angle:style&&style.angle;
var height=_approximateTextHeightInternal(text,style);
var width=_approximateTextWidthInternal(text,style);
var widthWithRotate=angle?_getSizeWithRotate(width,height,angle):width;
var heightWithRotate=angle?_getSizeWithRotate(height,width,angle):height;
return{
width:widthWithRotate*coefficients.widthOverlapCoef,
height:heightWithRotate*coefficients.heightOverlapCoef};

};exports.default=

{
approximateTextSize:approximateTextSize,
convertLengthToPixels:convertLengthToPixels};


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-util/textsize.js
// module id = 1395
// module chunks = 0